<div class="container text">
  <h3>A Report refresh is in progress</h3>
  <p>You’ll be able to share the Report once it completes</p>
</div>
